(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buyer-assistant"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const roots = document.querySelectorAll('[data-buyer-assistant]:not([data-buyer-ready])');

    roots.forEach((root) => {
      const launcher = root.querySelector('[data-buyer-open]');
      if (!launcher) return;

      let togglePanel = null;
      const hydrate = () => {
      if (togglePanel) return;
      root.dataset.buyerReady = 'true';

      const panel = root.querySelector('[data-buyer-panel]');
      const closeButton = root.querySelector('[data-buyer-close]');
      const progress = root.querySelector('[data-buyer-progress]');
      const form = root.querySelector('[data-buyer-form]');
      const family = root.querySelector('[data-buyer-family]');
      const need = root.querySelector('[data-buyer-need]');
      const capacity = root.querySelector('[data-buyer-capacity]');
      const zip = root.querySelector('[data-buyer-zip]');
      const timeline = root.querySelector('[data-buyer-timeline]');
      const continueLink = root.querySelector('[data-buyer-continue]');
      const routeButtons = [...root.querySelectorAll('[data-buyer-route]')];
      const proForm = root.querySelector('[data-buyer-pro-form]');
      const proQuery = root.querySelector('[data-buyer-pro-query]');
      const proSubmit = root.querySelector('[data-buyer-pro-submit]');
      const proAnswer = root.querySelector('[data-buyer-pro-answer]');
      const storageKey = 'umprotech-buyer-assistant-v2';
      const legacyStorageKey = 'umprotech-buyer-assistant-v1';
      const submitLabel = proSubmit.textContent.trim();
      let recommendationRequest = null;

      const state = {
        route: '',
        routeLabel: '',
        family: '',
        familyLabel: '',
        need: '',
        capacity: '',
        zip: '',
        timeline: ''
      };

      const formPaths = {
        machine_quote: '/pages/request-equipment-quote',
        service: '/pages/service-warranty',
        parts: '/pages/parts-consumables-support',
        financing: '/pages/equipment-financing-review-usa'
      };

      const formLabels = {
        machine_quote: root.dataset.proFormMachine,
        service: root.dataset.proFormService,
        parts: root.dataset.proFormParts,
        financing: root.dataset.proFormFinancing
      };

      const familySearch = {
        'fiber-laser-cutting-machines': 'fiber laser',
        'tube-laser-cutting-machines': 'tube laser',
        'hydraulic-press-brakes': 'press brake',
        'panel-benders': 'panel bender',
        'handheld-laser-welding-machines': 'laser welder',
        'laser-cleaning-machines': 'laser cleaner',
        'cnc-mills-machining-centers': 'CNC machining center',
        'cnc-lathes': 'CNC lathe',
        'industrial-band-saws': 'band saw',
        'support-equipment': 'compressor transformer'
      };

      const transition = (update) => {
        if (!document.startViewTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          update();
          return;
        }
        try {
          document.startViewTransition(update).finished.catch(() => {});
        } catch {
          update();
        }
      };

      const showStep = (step) => {
        transition(() => {
          root.querySelectorAll('[data-buyer-step]').forEach((screen) => {
            screen.hidden = screen.dataset.buyerStep !== String(step);
          });
          progress.textContent = String(step);
        });
      };

      const save = () => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            route: state.route,
            family: state.family,
            familyLabel: state.familyLabel
          }));
        } catch {
        }
      };

      const restore = () => {
        try {
          sessionStorage.removeItem(legacyStorageKey);
          const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
          state.route = typeof saved.route === 'string' ? saved.route : '';
          state.family = typeof saved.family === 'string' ? saved.family : '';
          state.familyLabel = typeof saved.familyLabel === 'string' ? saved.familyLabel : '';
        } catch {
        }

        family.value = state.family || '';

        if (!state.family && root.dataset.contextType === 'collection') {
          const option = [...family.options].find((item) => item.value === root.dataset.context);
          if (option) family.value = option.value;
        }

        const activeRoute = routeButtons.find((button) => button.dataset.buyerRoute === state.route);
        state.routeLabel = activeRoute?.textContent.trim() || '';
        routeButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button === activeRoute));
        });
      };

      const readFields = () => {
        state.family = family.value;
        state.familyLabel = family.selectedOptions[0]?.value ? family.selectedOptions[0].textContent.trim() : '';
        state.need = need.value.trim();
        state.capacity = capacity.value.trim();
        state.zip = zip.value.trim();
        state.timeline = timeline.value;
        save();
      };

      const setClassifiedState = (classification, query) => {
        state.route = classification.route;
        state.family = classification.family;
        state.need = query;

        const routeButton = routeButtons.find((button) => button.dataset.buyerRoute === state.route);
        state.routeLabel = routeButton?.textContent.trim() || '';
        routeButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button === routeButton));
        });

        family.value = state.family || 'not-sure';
        state.familyLabel = family.selectedOptions[0]?.textContent.trim() || '';
        need.value = query;
        save();
      };

      const classify = (query) => {
        const text = query.toLocaleLowerCase();
        const has = (pattern) => pattern.test(text);
        const hasFinancing = has(/financ|lease|monthly payment|credit|финанс|лизинг|кредит/iu);
        const hasParts = has(/parts?|consumable|nozzle|lens|filter|запчаст|сопл|линз|расход/iu);
        const hasService = has(/service|repair|diagnos|maintenance|alarm|error|сервис|ремонт|диагност|обслуж|ошиб/iu);

        let route = 'machine_quote';
        if (hasFinancing) route = 'financing';
        else if (hasParts && !hasService) route = 'parts';
        else if (hasService) route = 'service';

        let familyValue = '';
        let reason = root.dataset.proReasonGeneral;

        if (has(/tube|pipe|profile|structural|i-beam|труб|профил|балк/iu)) {
          familyValue = 'tube-laser-cutting-machines';
          reason = root.dataset.proReasonTube;
        } else if (has(/press brake|bend|bending|гиб|листогиб|пресс.?тормоз/iu)) {
          familyValue = 'hydraulic-press-brakes';
          reason = root.dataset.proReasonBrake;
        } else if (has(/panel bender|forming|folding|формов|панелегиб/iu)) {
          familyValue = 'panel-benders';
          reason = root.dataset.proReasonForming;
        } else if (has(/clean|rust|paint removal|очист|ржав|краск/iu)) {
          familyValue = 'laser-cleaning-machines';
          reason = root.dataset.proReasonCleaning;
        } else if (has(/weld|welding|свар/iu)) {
          familyValue = 'handheld-laser-welding-machines';
          reason = root.dataset.proReasonWelding;
        } else if (has(/lathe|turning|токар/iu)) {
          familyValue = 'cnc-lathes';
          reason = root.dataset.proReasonTurning;
        } else if (has(/mill|machining|machining center|фрезер|обрабатывающ/iu)) {
          familyValue = 'cnc-mills-machining-centers';
          reason = root.dataset.proReasonMachining;
        } else if (has(/band saw|bandsaw|sawing|ленточн.*пил|пилени/iu)) {
          familyValue = 'industrial-band-saws';
          reason = root.dataset.proReasonSaw;
        } else if (has(/compressor|chiller|transformer|extract|air dryer|компресс|чиллер|трансформ|вытяж/iu)) {
          familyValue = 'support-equipment';
          reason = root.dataset.proReasonSupport;
        } else if (has(/sheet|plate|fiber laser|laser cut|лист|плит|лазерн.*рез/iu)) {
          familyValue = 'fiber-laser-cutting-machines';
          reason = root.dataset.proReasonSheet;
        } else if (root.dataset.contextType === 'collection') {
          const option = [...family.options].find((item) => item.value === root.dataset.context);
          if (option) familyValue = option.value;
          reason = root.dataset.proReasonContext;
        } else if (root.dataset.contextType === 'product') {
          reason = root.dataset.proReasonContext;
        }

        if (route === 'financing') reason = root.dataset.proReasonFinancing;
        else if (route === 'parts') reason = root.dataset.proReasonParts;
        else if (route === 'service') reason = root.dataset.proReasonService;

        const routeSearch = {
          financing: 'equipment financing',
          parts: 'parts consumables',
          service: 'service'
        };

        return {
          route,
          family: familyValue || 'not-sure',
          search: routeSearch[route] || familySearch[familyValue] || query,
          reason
        };
      };

      const buildFormUrl = (requestState, source) => {
        const params = new URLSearchParams();
        params.set('route', requestState.route || 'machine_quote');
        params.set('source', source);
        params.set('source_path', location.pathname);
        if (requestState.need) params.set('application', requestState.need);
        if (requestState.zip) params.set('zip', requestState.zip);
        if (requestState.timeline) params.set('timeline', requestState.timeline);
        if (requestState.family && requestState.family !== 'not-sure') params.set('family', requestState.family);
        if (requestState.familyLabel) params.set('machine', requestState.familyLabel);
        if (requestState.capacity) params.set('capacity', requestState.capacity);
        if (requestState.route === 'service' && requestState.need) params.set('service', requestState.need);
        if (requestState.route === 'parts' && requestState.need) params.set('part', requestState.need);
        if (root.dataset.contextType === 'product' && root.dataset.context) params.set('machine', root.dataset.context);
        return `${formPaths[requestState.route] || formPaths.machine_quote}?${params.toString()}`;
      };

      const searchCatalog = async (query, signal) => {
        const url = new URL(root.dataset.proEndpoint, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,collection,page,article');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', root.dataset.proSectionId);

        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal
        });
        if (!response.ok) throw new Error(`Catalog search failed: ${response.status}`);

        const html = await response.text();
        const searchDocument = new DOMParser().parseFromString(html, 'text/html');
        const payload = searchDocument.querySelector('[data-umpro-search-results-payload]');
        if (!payload) throw new Error('Catalog results unavailable');

        return [...payload.querySelectorAll('.umpro-search__result')].flatMap((link) => {
          const href = link.getAttribute('href');
          const title = link.querySelector('strong')?.textContent.trim();
          if (!href || !title) return [];

          const destination = new URL(href, window.location.origin);
          if (destination.origin !== window.location.origin) return [];

          const groupId = link.closest('.umpro-search__group')?.querySelector('h3')?.id || '';
          const type = link.querySelector('.umpro-search__result-type')?.textContent.trim() || '';
          return [{
            href: `${destination.pathname}${destination.search}`,
            title,
            type,
            product: groupId === 'UmproSearchProducts',
            collection: groupId === 'UmproSearchCollections'
          }];
        });
      };

      const productsFromCollection = async (resource, signal) => {
        const url = new URL(resource.href, window.location.origin);
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal
        });
        if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

        const html = await response.text();
        const collectionDocument = new DOMParser().parseFromString(html, 'text/html');
        const groups = new Map();

        collectionDocument.querySelectorAll('a[href*="/products/"]').forEach((link) => {
          const href = link.getAttribute('href');
          if (!href) return;
          const destination = new URL(href, window.location.origin);
          if (destination.origin !== window.location.origin || !destination.pathname.startsWith('/products/')) return;
          const key = destination.pathname;
          const group = groups.get(key) || [];
          group.push(link);
          groups.set(key, group);
        });

        return [...groups.entries()].flatMap(([href, links]) => {
          const cleanLink = links.find((link) => {
            const text = link.textContent.trim().replace(/\s+/g, ' ');
            return !link.getAttribute('aria-label') && text.length > 12 && text.length < 180 && !/^view details$/iu.test(text);
          });
          const mediaLink = links.find((link) => link.getAttribute('aria-label'));
          const title = cleanLink?.textContent.trim().replace(/\s+/g, ' ')
            || mediaLink?.getAttribute('aria-label')?.replace(/^View details for\s+/iu, '').trim()
            || '';
          if (!title) return [];
          return [{
            href,
            title,
            type: root.dataset.proProductLabel,
            product: true,
            collection: false
          }];
        });
      };

      const enrichProductResources = async (resources, classification, signal) => {
        const directProducts = resources.filter((resource) => resource.product);
        if (classification.route !== 'machine_quote' || directProducts.length >= 3) return resources;

        const collections = resources
          .filter((resource) => resource.collection)
          .filter((resource) => !/compressor|parts?|consumable|rental|service|training|financ/iu.test(resource.title))
          .slice(0, 2);
        const discovered = [];

        for (const collectionResource of collections) {
          try {
            discovered.push(...await productsFromCollection(collectionResource, signal));
          } catch (error) {
            if (error.name === 'AbortError') throw error;
          }
          if (directProducts.length + discovered.length >= 3) break;
        }

        const seen = new Set();
        return [...directProducts, ...discovered, ...resources.filter((resource) => !resource.product)].filter((resource) => {
          if (seen.has(resource.href)) return false;
          seen.add(resource.href);
          return true;
        });
      };

      const fetchRecommendations = async (query, fallback, signal) => {
        const primary = await searchCatalog(query, signal);
        if (query.toLocaleLowerCase() === fallback.toLocaleLowerCase()) return primary;

        let secondary = [];
        try {
          secondary = await searchCatalog(fallback, signal);
        } catch (error) {
          if (!primary.length || error.name === 'AbortError') throw error;
        }

        const seen = new Set();
        return [...primary, ...secondary].filter((resource) => {
          if (seen.has(resource.href)) return false;
          seen.add(resource.href);
          return true;
        });
      };

      const appendResources = (container, title, resources) => {
        if (!resources.length) return;
        const heading = document.createElement('h5');
        heading.textContent = title;
        container.append(heading);

        const list = document.createElement('ul');
        list.className = 'buyer-assistant__resource-list';
        resources.forEach((resource) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const type = document.createElement('small');
          type.textContent = resource.type;
          link.href = resource.href;
          link.append(type, document.createTextNode(resource.title));
          item.append(link);
          list.append(item);
        });
        container.append(list);
      };

      const renderRecommendation = (classification, query, resources, failed) => {
        const products = resources.filter((resource) => resource.product).slice(0, 3);
        const guides = resources.filter((resource) => !resource.product).slice(0, 3);

        transition(() => {
          proAnswer.replaceChildren();

          const title = document.createElement('h4');
          title.textContent = root.dataset.proAnswerTitle;
          const reason = document.createElement('p');
          reason.textContent = classification.reason;
          proAnswer.append(title, reason);

          if (failed) {
            const error = document.createElement('p');
            error.textContent = root.dataset.proError;
            proAnswer.append(error);
          } else if (!products.length && !guides.length) {
            const empty = document.createElement('p');
            empty.textContent = root.dataset.proNoResults;
            proAnswer.append(empty);
          }

          appendResources(proAnswer, root.dataset.proProductsTitle, products);
          appendResources(proAnswer, root.dataset.proGuidesTitle, guides);

          const safety = document.createElement('p');
          safety.textContent = root.dataset.proSafety;
          proAnswer.append(safety);

          const formPrefix = document.createElement('p');
          formPrefix.textContent = root.dataset.proFormPrefix;
          proAnswer.append(formPrefix);

          const actions = document.createElement('div');
          actions.className = 'buyer-assistant__pro-actions';

          const formLink = document.createElement('a');
          formLink.className = 'buyer-assistant__primary';
          formLink.href = buildFormUrl(state, 'buyer-assistant-pro');
          formLink.textContent = formLabels[classification.route] || formLabels.machine_quote;

          const refine = document.createElement('button');
          refine.className = 'buyer-assistant__secondary';
          refine.type = 'button';
          refine.textContent = root.dataset.proRefine;
          refine.addEventListener('click', () => {
            showStep(2);
            family.focus();
          });

          const searchUrl = new URL('/search', window.location.origin);
          searchUrl.searchParams.set('q', classification.search);
          searchUrl.searchParams.set('options[prefix]', 'last');
          const searchAll = document.createElement('a');
          searchAll.className = 'buyer-assistant__search-all';
          searchAll.href = `${searchUrl.pathname}${searchUrl.search}`;
          searchAll.textContent = root.dataset.proSearchAll;

          actions.append(formLink, refine, searchAll);
          proAnswer.append(actions);
          proAnswer.setAttribute('aria-busy', 'false');
        });
      };

      const close = () => {
        recommendationRequest?.abort();
        panel.hidden = true;
        launcher.setAttribute('aria-expanded', 'false');
        launcher.focus();
      };

      const open = () => {
        restore();
        proSubmit.disabled = false;
        proSubmit.textContent = submitLabel;
        panel.hidden = false;
        launcher.setAttribute('aria-expanded', 'true');
        showStep(1);
        proQuery.focus();
      };

      proForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!proForm.reportValidity()) return;

        const query = proQuery.value.trim();
        const classification = classify(query);
        setClassifiedState(classification, query);

        recommendationRequest?.abort();
        const request = new AbortController();
        recommendationRequest = request;
        proAnswer.hidden = false;
        proAnswer.setAttribute('aria-busy', 'true');
        proAnswer.textContent = root.dataset.proLoading;
        proSubmit.disabled = true;
        proSubmit.textContent = root.dataset.proLoading;

        let resources = [];
        let failed = false;
        try {
          resources = await fetchRecommendations(query, classification.search, request.signal);
          resources = await enrichProductResources(resources, classification, request.signal);
        } catch (error) {
          if (error.name === 'AbortError') return;
          failed = true;
        } finally {
          if (!request.signal.aborted && recommendationRequest === request) {
            proSubmit.disabled = false;
            proSubmit.textContent = submitLabel;
          }
        }

        if (request.signal.aborted || recommendationRequest !== request) return;
        renderRecommendation(classification, query, resources, failed);
        document.dispatchEvent(new CustomEvent('buyer-assistant:recommendation', {
          detail: {
            route: classification.route,
            family: classification.family,
            queryLength: query.length,
            resultCount: resources.length
          }
        }));
      });

      root.querySelectorAll('[data-buyer-pro-prompt]').forEach((button) => {
        button.addEventListener('click', () => {
          proQuery.value = button.dataset.buyerProPrompt || '';
          proForm.requestSubmit();
        });
      });

      routeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.route = button.dataset.buyerRoute || 'machine_quote';
          state.routeLabel = button.textContent.trim();
          routeButtons.forEach((item) => {
            item.setAttribute('aria-pressed', String(item === button));
          });
          save();
          showStep(2);
          family.focus();
        });
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;

        readFields();
        continueLink.href = buildFormUrl(state, 'buyer-assistant-pro');

        const empty = root.dataset.emptyLabel || '';
        root.querySelector('[data-buyer-summary-route]').textContent = state.routeLabel || empty;
        root.querySelector('[data-buyer-summary-family]').textContent = state.familyLabel || empty;
        root.querySelector('[data-buyer-summary-need]').textContent = state.need || empty;
        root.querySelector('[data-buyer-summary-zip]').textContent = state.zip || empty;
        root.querySelector('[data-buyer-summary-timeline]').textContent = timeline.selectedOptions[0]?.textContent.trim() || empty;

        showStep(3);
        continueLink.focus();
      });

      root.querySelector('[data-buyer-back]').addEventListener('click', () => {
        readFields();
        showStep(1);
        proQuery.focus();
      });

      root.querySelector('[data-buyer-edit]').addEventListener('click', () => {
        showStep(2);
        family.focus();
      });

      root.querySelector('[data-buyer-reset]').addEventListener('click', () => {
        recommendationRequest?.abort();
        try {
          sessionStorage.removeItem(storageKey);
          sessionStorage.removeItem(legacyStorageKey);
        } catch {
        }
        Object.assign(state, {
          route: '',
          routeLabel: '',
          family: '',
          familyLabel: '',
          need: '',
          capacity: '',
          zip: '',
          timeline: ''
        });
        form.reset();
        proForm.reset();
        proAnswer.replaceChildren();
        proAnswer.hidden = true;
        routeButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
        showStep(1);
        proQuery.focus();
      });

      togglePanel = () => {
        if (panel.hidden) open();
        else close();
      };
      closeButton.addEventListener('click', close);

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) close();
      });

      [family, need, capacity, zip, timeline].forEach((field) => {
        field.addEventListener('change', readFields);
      });

      restore();
      };

      const ensureHydrated = () => {
        if (!togglePanel) hydrate();
      };

      launcher.addEventListener('pointerenter', ensureHydrated, { once: true, passive: true });
      launcher.addEventListener('focus', ensureHydrated, { once: true });
      launcher.addEventListener('click', () => {
        ensureHydrated();
        togglePanel?.();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["process-catalog-explorer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-process-catalog]').forEach((root) => {
  if (root.dataset.processCatalogReady === 'true') return;
  root.dataset.processCatalogReady = 'true';
  const tabs = Array.from(root.querySelectorAll('[data-process-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-process-panel]'));

  const activate = (nextTab, moveFocus) => {
    tabs.forEach((tab) => {
      const active = tab === nextTab;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel) => {
      panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
    });
    if (moveFocus) nextTab.focus();
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab, false));
    tab.addEventListener('keydown', (event) => {
      let nextIndex = index;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === index) return;
      event.preventDefault();
      activate(tabs[nextIndex], true);
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rfq-five-step"] && !Shopify.designMode) return;
  try {
    class UmproRfqSteps extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => window.setTimeout(() => this.init(), 0), { once: true });
      } else {
        window.setTimeout(() => this.init(), 0);
      }
    }

    init() {
      this.root = document.querySelector('[data-smart-form-root][data-form-mode="smart"]');
      if (!this.root) return;
      this.form = this.root.querySelector('form.smart-form');
      if (!(this.form instanceof HTMLFormElement)) {
        this.renderReceipt();
        return;
      }

      this.routeSelector = this.form.querySelector('[data-route-selector]');
      this.routeField = this.form.querySelector('[data-route-field]');
      this.routeSection = this.form.querySelector('.smart-form__section--route');
      this.routeGroups = Array.from(this.form.querySelectorAll('[data-route-group]'));
      this.contactSection = this.form.querySelector('.smart-form__section--contact');
      this.footer = this.form.querySelector('.smart-form__footer');
      if (!this.routeSection || !this.contactSection || !this.footer || !this.routeGroups.length) return;

      this.stepper = this.clone('[data-rfq-stepper-template]');
      this.readiness = this.clone('[data-rfq-readiness-template]');
      this.review = this.clone('[data-rfq-review-template]');
      this.actions = this.clone('[data-rfq-actions-template]');
      this.form.insertBefore(this.stepper, this.form.firstChild);
      this.form.insertBefore(this.readiness, this.contactSection);
      this.form.insertBefore(this.review, this.footer);
      this.form.insertBefore(this.actions, this.footer);

      this.status = this.stepper.querySelector('[data-rfq-step-status]');
      this.stepButtons = Array.from(this.stepper.querySelectorAll('[data-rfq-step-button]'));
      this.backButton = this.actions.querySelector('[data-rfq-back]');
      this.nextButton = this.actions.querySelector('[data-rfq-next]');
      this.error = this.actions.querySelector('[data-rfq-error]');
      this.reviewList = this.review.querySelector('[data-rfq-review-list]');
      this.reference = this.review.querySelector('[data-rfq-reference]');
      this.contextReview = this.review.querySelector('[data-rfq-context-review]');
      this.contextField = this.form.querySelector('[data-context-field]');
      this.machineHandoff = this.isMachineHandoff();
      this.storageKey = `umprotech-rfq-step:${location.pathname}:${this.machineHandoff ? 'machine-handoff' : 'general'}`;
      this.referenceKey = `umprotech-rfq-reference:${location.pathname}`;
      this.submissionReference = this.getReference();
      this.current = 1;
      this.furthest = 1;
      this.submitting = false;
      this.transitioning = false;

      [this.routeSection, ...this.routeGroups, this.contactSection].forEach((section) => {
        section.querySelector('h2')?.setAttribute('tabindex', '-1');
      });

      this.addHidden('contact[RFQ workflow]', 'Five-step conditional workflow v1', 'workflow-version');
      this.addHidden('contact[Request reference]', this.submissionReference, 'request-reference');
      this.reference.textContent = this.submissionReference;
      this.syncReadiness();
      this.applyHandoff();
      this.restoreStep();
      this.applyMachineHandoff();

      this.nextButton.addEventListener('click', () => this.next());
      this.backButton.addEventListener('click', () => this.show(this.current - 1, true));
      this.stepButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = Number(button.dataset.rfqStepButton || 1);
          if (target <= this.furthest) this.show(target, true);
        });
      });

      this.routeSelector?.addEventListener('change', () => {
        this.syncReadiness();
        this.current = 1;
        this.furthest = 1;
        this.show(1, false);
      });

      this.readiness.addEventListener('input', () => this.saveStep());
      this.readiness.addEventListener('change', () => this.saveStep());

      this.form.addEventListener('keydown', (event) => {
        const target = event.target;
        if (event.key === 'Enter' && this.current < 5 && !(target instanceof HTMLTextAreaElement)) {
          event.preventDefault();
          this.next();
        }
      });

      this.form.addEventListener('submit', (event) => {
        if (this.current < 5) {
          event.preventDefault();
          this.next();
          return;
        }
        if (this.submitting) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        this.submitting = true;
        this.addHidden('contact[Completed RFQ steps]', this.machineHandoff ? '4 of 4 — machine route preselected' : '5 of 5', 'completed-steps');
        const submitText = this.footer.querySelector('[data-submit-button] span');
        if (submitText) submitText.textContent = this.dataset.submitting || submitText.textContent;
      });

      this.show(this.current, false);
    }

    clone(selector) {
      const template = this.querySelector(selector);
      return template.content.firstElementChild.cloneNode(true);
    }

    get route() {
      return this.routeField?.value || this.routeSelector?.value || 'machine_quote';
    }

    isMachineHandoff() {
      const params = new URLSearchParams(location.search);
      const requested = String(params.get('route') || params.get('request') || params.get('request_type') || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
      const source = String(params.get('source') || '').trim().toLowerCase();
      const hasMachineContext = ['machine', 'machines', 'model', 'models', 'product_title', 'comparison'].some((key) => Boolean(params.get(key)));
      const machineRoute = ['machine', 'machine_quote', 'quote', 'equipment', 'equipment_quote'].includes(requested);
      const productSource = ['product', 'product-card', 'sticky-product', 'smart-shortlist', 'project-builder'].includes(source);
      return hasMachineContext && (machineRoute || productSource);
    }

    applyMachineHandoff() {
      if (!this.machineHandoff) return;
      if (this.routeSelector instanceof HTMLSelectElement) this.routeSelector.value = 'machine_quote';
      if (this.routeField instanceof HTMLInputElement) this.routeField.value = 'machine_quote';
      const firstStepItem = this.stepButtons[0]?.closest('li');
      if (firstStepItem) firstStepItem.hidden = true;
      this.stepButtons.slice(1).forEach((button, index) => {
        const number = button.querySelector('span');
        if (number) number.textContent = String(index + 1);
      });
      this.stepper.classList.add('is-machine-handoff');
      const inquiry = this.root;
      [
        ['.smart-inquiry__hero .smart-inquiry__eyebrow', this.dataset.machineEyebrow],
        ['.smart-inquiry__hero h1', this.dataset.machineTitle],
        ['.smart-inquiry__hero .smart-inquiry__lede', this.dataset.machineIntro],
        ['.smart-inquiry__side h2', this.dataset.machineSideTitle],
        ['.smart-inquiry__side h2 + p', this.dataset.machineSideIntro]
      ].forEach(([selector, value]) => {
        const element = inquiry?.querySelector(selector);
        if (element && value) element.textContent = value;
      });
      const machineSection = this.routeGroups.find((group) => String(group.dataset.routeGroup || '').split(',').map((route) => route.trim()).includes('machine_quote'));
      [machineSection, this.readiness, this.contactSection, this.review].forEach((section, index) => {
        const number = section?.querySelector('.smart-form__section-heading > span');
        if (number) number.textContent = String(index + 1).padStart(2, '0');
      });
      this.current = Math.max(2, this.current);
      this.furthest = Math.max(2, this.furthest);
      this.addHidden('contact[RFQ handoff]', 'Product-aware machine route', 'handoff-mode');
      this.syncReadiness();
    }

    groupsFor(step) {
      if (step === 1) return [this.routeSection];
      if (step === 2) return this.routeGroups;
      if (step === 3) return [this.readiness];
      if (step === 4) return [this.contactSection];
      return [this.review];
    }

    show(step, focusHeading) {
      if (this.transitioning) return;
      const minimum = this.machineHandoff ? 2 : 1;
      const target = Math.max(minimum, Math.min(5, step));
      const change = () => {
        for (let index = 1; index <= 5; index += 1) {
          this.groupsFor(index).forEach((group) => group.classList.toggle('rfq-step-is-hidden', index !== target));
        }
        this.current = target;
        this.furthest = Math.max(this.furthest, target);
        if (target === 3) this.syncReadiness();
        if (target === 5) this.buildReview();
        this.footer.classList.toggle('rfq-footer-is-hidden', target !== 5);
        this.backButton.hidden = target === minimum;
        this.nextButton.hidden = target === 5;
        this.error.hidden = true;
        this.updateStepper();
        this.saveStep();
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.transitioning = true;
        this.nextButton.disabled = true;
        const transition = document.startViewTransition(change);
        transition.finished.finally(() => {
          this.transitioning = false;
          this.nextButton.disabled = false;
        });
      } else {
        change();
      }

      if (focusHeading) {
        window.setTimeout(() => {
          const visible = this.groupsFor(target).find((group) => !group.hidden);
          visible?.querySelector('h2, [data-rfq-heading]')?.focus({ preventScroll: false });
        }, 80);
      }
      this.track('lead_form_step_view_v1', target);
    }

    next() {
      if (!this.validateStep(this.current)) return;
      this.show(this.current + 1, true);
    }

    validateStep(step) {
      const containers = this.groupsFor(step).filter((group) => !group.hidden && !group.classList.contains('rfq-step-is-hidden'));
      const fields = containers.flatMap((group) => Array.from(group.querySelectorAll('input, select, textarea')))
        .filter((field) => !field.disabled && field.required);
      const invalid = fields.find((field) => !field.checkValidity());
      if (!invalid) {
        this.error.hidden = true;
        return true;
      }
      this.error.hidden = false;
      invalid.reportValidity();
      invalid.focus();
      return false;
    }

    syncReadiness() {
      if (!this.readiness) return;
      const route = this.route;
      this.readiness.querySelectorAll('[data-rfq-routes]').forEach((wrapper) => {
        const routes = String(wrapper.dataset.rfqRoutes || '').split(',');
        const requiredRoutes = String(wrapper.dataset.rfqRequiredRoutes || '').split(',');
        const visible = routes.includes(route);
        wrapper.hidden = !visible;
        wrapper.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !visible;
          field.required = visible && requiredRoutes.includes(route);
        });
        wrapper.querySelectorAll('[data-rfq-required-indicator]').forEach((indicator) => {
          indicator.hidden = !(visible && requiredRoutes.includes(route));
        });
      });
    }

    applyHandoff() {
      const params = new URLSearchParams(location.search);
      const extraKeys = ['power', 'demand', 'working_size', 'design', 'project_power', 'compressor', 'delivery', 'unloading', 'installation', 'training', 'financing', 'project_timing'];
      const additions = extraKeys.flatMap((key) => {
        const value = params.get(key);
        return value ? [`${key}=${value}`] : [];
      });
      const appendContext = () => {
        if (!additions.length || !this.contextField) return;
        const values = this.contextField.value.trim() ? this.contextField.value.split('; ').filter(Boolean) : [];
        additions.forEach((addition) => {
          if (!values.includes(addition)) values.push(addition);
        });
        this.contextField.value = values.join('; ');
      };
      appendContext();
      const appendAfterReady = () => window.setTimeout(appendContext, 0);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', appendAfterReady, { once: true });
      else appendAfterReady();

      const workingSize = params.get('working_size');
      const workingField = this.form.elements.namedItem('contact[Required working size]');
      if (workingSize && workingField instanceof HTMLInputElement && !workingField.value) {
        const sizeMap = { '4x8': '4 × 8 ft', '5x10': '5 × 10 ft', '5ft': 'Up to 5 ft', '8ft': 'Up to 8 ft', '10ft': 'Up to 10 ft' };
        workingField.value = sizeMap[workingSize] || workingSize;
      }

      const design = params.get('design');
      const layoutField = this.form.elements.namedItem('contact[Machine spec — Machine layout]');
      if (design && layoutField instanceof HTMLSelectElement) {
        const match = Array.from(layoutField.options).find((option) => {
          const text = option.textContent.toLowerCase();
          return design === 'open' || design === 'open-table' ? text === 'open table' : design === 'enclosed' && text === 'enclosed exchange table';
        });
        if (match) layoutField.value = match.value;
      }

      const power = params.get('power');
      const powerField = this.readiness.querySelector('[name="contact[Available shop power]"]');
      if (power && powerField instanceof HTMLSelectElement && !powerField.value) {
        const token = power === 'single_phase' ? 'single-phase' : power === 'three_phase' ? 'three-phase available' : power === '480_three_phase' ? '480v three-phase' : power === 'other' ? 'other or multiple' : 'not sure';
        const match = Array.from(powerField.options).find((option) => option.textContent.toLowerCase().includes(token));
        if (match) powerField.value = match.value;
      }

      const selectByText = (field, token) => {
        if (!(field instanceof HTMLSelectElement) || field.value || !token) return;
        const match = Array.from(field.options).find((option) => option.textContent.trim().toLowerCase().includes(token.toLowerCase()));
        if (match) field.value = match.value;
      };

      const projectPower = params.get('project_power') || '';
      const utilityField = this.readiness.querySelector('[name="contact[Utility readiness]"]');
      if (projectPower.toLowerCase().includes('transformer')) selectByText(utilityField, 'changes are planned');
      else if (projectPower) selectByText(utilityField, 'site-readiness review');

      const unloading = params.get('unloading') || '';
      selectByText(this.readiness.querySelector('[name="contact[Unloading capability]"]'), unloading);

      const installation = params.get('installation') || '';
      const training = params.get('training') || '';
      let startupToken = '';
      if (installation.toLowerCase().includes('on-site') && training.toLowerCase().includes('on-site')) startupToken = 'on-site installation, startup and training';
      else if (installation.toLowerCase().includes('on-site')) startupToken = 'startup and testing only';
      else if (installation.toLowerCase().includes('remote') || training.toLowerCase().includes('remote')) startupToken = 'remote support or training';
      else if (installation.toLowerCase().includes('customer-arranged') && training.toLowerCase().includes('no training')) startupToken = 'not required';
      else if (installation || training) startupToken = 'not sure';
      selectByText(this.readiness.querySelector('[name="contact[Installation and training]"]'), startupToken);

      const financing = params.get('financing') || '';
      if (financing) selectByText(this.readiness.querySelector('[name="contact[Financing review]"]'), financing.toLowerCase().startsWith('include') ? 'yes' : 'no');

      const targetTiming = this.readiness.querySelector('[name="contact[Project timing]"]');
      const purchaseTiming = this.form.elements.namedItem('contact[Purchase timing]');
      const financingTiming = this.form.elements.namedItem('contact[Financing purchase timing]');
      const projectTiming = params.get('project_timing') || '';
      if (projectTiming) selectByText(targetTiming, projectTiming);
      const sourceTiming = purchaseTiming instanceof HTMLSelectElement && purchaseTiming.value ? purchaseTiming : financingTiming;
      if (targetTiming instanceof HTMLSelectElement && sourceTiming instanceof HTMLSelectElement && !targetTiming.value && sourceTiming.value) {
        const match = Array.from(targetTiming.options).find((option) => option.textContent.trim() === sourceTiming.selectedOptions[0]?.textContent?.trim());
        if (match) targetTiming.value = match.value;
      }

      if (params.get('source') === 'project-builder') {
        this.addHidden('contact[Project builder version]', '2026.08-project-1', 'project-builder-version');
        [
          ['project_power', 'contact[Project power support]', 'project-power', this.dataset.projectPowerLabel],
          ['compressor', 'contact[Project compressor scope]', 'project-compressor', this.dataset.projectCompressorLabel],
          ['delivery', 'contact[Project delivery plan]', 'project-delivery', this.dataset.projectDeliveryLabel],
          ['training', 'contact[Project training plan]', 'project-training', this.dataset.projectTrainingLabel]
        ].forEach(([param, name, key, label]) => {
          const value = params.get(param) || '';
          if (!value) return;
          const input = this.addHidden(name, value, key);
          input.dataset.summaryLabel = label;
        });
      }
    }

    buildReview() {
      this.reviewList.replaceChildren();
      const entries = [];
      this.form.querySelectorAll('[data-summary-label]').forEach((field) => {
        if (field.disabled || !field.name) return;
        let value = '';
        if (field instanceof HTMLSelectElement) {
          if (!field.value) return;
          value = field.selectedOptions[0]?.textContent?.trim() || '';
        }
        else if (field instanceof HTMLInputElement && ['checkbox', 'radio'].includes(field.type)) value = field.checked ? field.value : '';
        else value = String(field.value || '').trim();
        if (!value || value === 'Select one') return;
        entries.push([field.dataset.summaryLabel || field.name, value]);
      });

      if (!entries.length) entries.push(['', this.dataset.empty || 'No optional details were entered.']);
      entries.forEach(([label, value]) => {
        const term = document.createElement('dt');
        const description = document.createElement('dd');
        term.textContent = label;
        description.textContent = value;
        this.reviewList.append(term, description);
      });

      const context = this.contextField?.value?.trim() || '';
      this.contextReview.hidden = !context;
      const contextText = this.contextReview.querySelector('span');
      if (contextText) contextText.textContent = context;
      this.reference.textContent = this.submissionReference;
    }

    updateStepper() {
      const titles = this.stepButtons.map((button) => button.textContent.replace(/^\s*\d+\s*/, '').trim());
      this.stepButtons.forEach((button, index) => {
        const step = index + 1;
        button.toggleAttribute('aria-current', step === this.current);
        if (step === this.current) button.setAttribute('aria-current', 'step');
        button.classList.toggle('is-complete', step < this.current || step < this.furthest);
        button.disabled = step > this.furthest;
      });
      const visibleCurrent = this.machineHandoff ? this.current - 1 : this.current;
      const total = this.machineHandoff ? 4 : 5;
      const status = String(this.dataset.statusTemplate || '__CURRENT__/__TOTAL__ __TITLE__')
        .replace('__CURRENT__', String(visibleCurrent))
        .replace('__TOTAL__', String(total))
        .replace('__TITLE__', titles[this.current - 1] || '');
      this.status.textContent = status;
    }

    addHidden(name, value, key) {
      let input = this.form.querySelector(`[data-rfq-meta="${CSS.escape(key)}"]`);
      if (!(input instanceof HTMLInputElement)) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.dataset.rfqMeta = key;
        this.form.prepend(input);
      }
      input.value = value;
      return input;
    }

    saveStep() {
      try {
        const readiness = {};
        const safeReadiness = new Set([
          'contact[Available shop power]',
          'contact[Utility readiness]',
          'contact[Unloading capability]',
          'contact[Installation and training]',
          'contact[Financing review]',
          'contact[Project timing]'
        ]);
        this.readiness.querySelectorAll('input, select, textarea').forEach((field) => {
          if (field.name && !field.disabled && safeReadiness.has(field.name)) readiness[field.name] = field.value;
        });
        sessionStorage.setItem(this.storageKey, JSON.stringify({ step: this.current, route: this.route, readiness, expiresAt: Date.now() + 7200000 }));
      } catch {}
    }

    restoreStep() {
      try {
        const value = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        if (value && Number(value.expiresAt) > Date.now() && value.route === this.route) {
          const safeReadiness = new Set([
            'contact[Available shop power]',
            'contact[Utility readiness]',
            'contact[Unloading capability]',
            'contact[Installation and training]',
            'contact[Financing review]',
            'contact[Project timing]'
          ]);
          Object.entries(value.readiness || {}).forEach(([name, fieldValue]) => {
            if (!safeReadiness.has(name)) return;
            const field = this.form.elements.namedItem(name);
            if (field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) {
              field.value = String(fieldValue || '');
            }
          });
          this.current = Math.max(1, Math.min(4, Number(value.step) || 1));
          this.furthest = this.current;
        } else {
          sessionStorage.removeItem(this.storageKey);
        }
      } catch {}
    }

    getReference() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.referenceKey) || 'null');
        if (saved && Number(saved.expiresAt) > Date.now() && saved.value) return saved.value;
      } catch {}
      const date = new Date().toISOString().slice(0, 10).replaceAll('-', '');
      const bytes = new Uint8Array(4);
      crypto.getRandomValues(bytes);
      const suffix = Array.from(bytes).map((byte) => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
      const value = `UM-RFQ-${date}-${suffix}`;
      try {
        sessionStorage.setItem(this.referenceKey, JSON.stringify({ value, expiresAt: Date.now() + 86400000 }));
      } catch {}
      return value;
    }

    renderReceipt() {
      const success = this.root.querySelector('[data-form-success]');
      if (!success || success.querySelector('[data-rfq-receipt]')) return;
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(`umprotech-rfq-reference:${location.pathname}`) || 'null'); } catch {}
      if (!saved?.value) return;
      const receipt = this.clone('[data-rfq-receipt-template]');
      receipt.querySelector('code').textContent = saved.value;
      success.append(receipt);
    }

    track(event, step) {
      if (!window.UmproThemeConfig?.analyticsEnabled) return;
      const details = { step, request_route: this.route, page_path: location.pathname };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...details });
      if (typeof window.umprotechTrack === 'function') window.umprotechTrack(event, details);
    }
  }

  if (!customElements.get('umpro-rfq-steps')) {
    customElements.define('umpro-rfq-steps', UmproRfqSteps);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smart-shortlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('SmartMachineShortlist');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const storageKey = 'umprotech.machineShortlist.v2';
    const focusStorageKey = 'umprotech.machineShortlist.focus.v1';
    const maximum = 3;
    const dock = root.querySelector('[data-shortlist-open]')?.closest('.smart-shortlist__dock');
    const slots = root.querySelector('[data-shortlist-slots]');
    const count = root.querySelector('[data-shortlist-count]');
    const compareButton = root.querySelector('[data-shortlist-open]');
    const compareLabel = root.querySelector('[data-shortlist-compare-label]');
    const clearButton = root.querySelector('[data-shortlist-clear]');
    const dialog = root.querySelector('[data-shortlist-dialog]');
    const closeButton = root.querySelector('[data-shortlist-close]');
    const differencesToggle = root.querySelector('[data-shortlist-differences]');
    const tableHost = root.querySelector('[data-shortlist-table]');
    const readinessHost = root.querySelector('[data-shortlist-readiness]');
    const decisionHost = root.querySelector('[data-shortlist-decision]');
    const focusInputs = root.querySelectorAll('[data-shortlist-focus] input');
    const quoteLink = root.querySelector('[data-shortlist-quote]');
    const shareButton = root.querySelector('[data-shortlist-share]');
    const printButton = root.querySelector('[data-shortlist-print]');
    const live = root.querySelector('[data-shortlist-live]');
    const sourceMap = new Map();
    const allowedFocus = new Set(['balanced', 'power', 'area', 'readiness']);
    const allowedKeys = ['handle', 'title', 'url', 'image', 'model', 'family', 'power', 'workingArea', 'electrical', 'air', 'installation', 'training'];
    let shortlist = readStorage();
    let decisionFocus = readFocus();
    let dialogOpener = null;

    root.querySelectorAll('[data-smart-shortlist-source]').forEach((source) => {
      const item = sanitize(source.dataset);
      if (item.handle) sourceMap.set(item.handle, item);
    });
    focusInputs.forEach((input) => {
      input.checked = input.value === decisionFocus;
    });

    function sanitize(value) {
      const clean = {};
      allowedKeys.forEach((key) => {
        clean[key] = typeof value?.[key] === 'string' ? value[key].trim() : '';
      });
      return clean;
    }

    function readStorage() {
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.slice(0, maximum).map(sanitize).filter((item) => item.handle);
      } catch {
        return [];
      }
    }

    function writeStorage() {
      try {
        localStorage.setItem(storageKey, JSON.stringify(shortlist));
      } catch {
        return;
      }
    }

    function readFocus() {
      const shared = new URLSearchParams(window.location.search).get('focus');
      if (allowedFocus.has(shared)) return shared;
      try {
        const stored = localStorage.getItem(focusStorageKey);
        return allowedFocus.has(stored) ? stored : 'balanced';
      } catch {
        return 'balanced';
      }
    }

    function writeFocus() {
      try {
        localStorage.setItem(focusStorageKey, decisionFocus);
      } catch {
        return;
      }
    }

    function announce(message) {
      if (!live) return;
      live.textContent = '';
      window.setTimeout(() => {
        live.textContent = message;
      }, 20);
    }

    function transitionRender() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduced) {
        document.startViewTransition(render);
      } else {
        render();
      }
    }

    function make(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }

    function makeMedia(item, className) {
      if (item.image) {
        const image = make('img', className);
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        return image;
      }
      const placeholder = make('span', className || '');
      placeholder.setAttribute('aria-hidden', 'true');
      return placeholder;
    }

    function renderSlots() {
      if (!slots) return;
      slots.replaceChildren();
      for (let index = 0; index < maximum; index += 1) {
        const item = shortlist[index];
        if (!item) {
          slots.append(make('span', 'smart-shortlist__slot smart-shortlist__slot--empty', root.dataset.empty));
          continue;
        }
        const slot = make('article', 'smart-shortlist__slot');
        slot.append(makeMedia(item, 'smart-shortlist__slot-media'));
        slot.append(make('strong', '', item.model || item.title));
        const remove = make('button', '', '×');
        remove.type = 'button';
        remove.dataset.shortlistRemove = item.handle;
        remove.setAttribute('aria-label', `${root.dataset.remove}: ${item.title}`);
        slot.append(remove);
        slots.append(slot);
      }
    }

    function renderButtons() {
      document.querySelectorAll('.smart-shortlist-trigger').forEach((button) => {
        const handle = button.dataset.shortlistHandle;
        const selected = shortlist.some((item) => item.handle === handle);
        button.setAttribute('aria-pressed', String(selected));
        const label = button.querySelector('[data-shortlist-action-label]');
        const nextLabel = selected ? root.dataset.added : root.dataset.add;
        if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
        const path = button.querySelector('svg path');
        const nextPath = selected ? 'M5 12.5 9.2 17 19 7' : 'M12 5v14M5 12h14';
        if (path && path.getAttribute('d') !== nextPath) path.setAttribute('d', nextPath);
      });
    }

    function render() {
      if (dock) dock.hidden = shortlist.length === 0;
      if (count) count.textContent = String(shortlist.length);
      if (compareButton) compareButton.disabled = shortlist.length < 2;
      if (compareLabel) compareLabel.textContent = `${root.dataset.compare} (${shortlist.length})`;
      renderSlots();
      renderButtons();
      if (dialog?.open) renderTable();
    }

    function fallbackFromCard(card, handle) {
      const link = card.querySelector('.machine-card__title a, a[href*="/products/"]');
      const values = card.querySelectorAll('.machine-card__specs dd');
      return sanitize({
        handle,
        title: card.querySelector('.machine-card__title')?.textContent || handle,
        url: link?.getAttribute('href') || `/products/${handle}`,
        image: card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '',
        workingArea: values[0]?.textContent || '',
        power: values[1]?.textContent || ''
      });
    }

    async function fetchSource(card, handle) {
      if (sourceMap.has(handle)) return sourceMap.get(handle);
      const fallback = fallbackFromCard(card, handle);
      try {
        const response = await fetch(fallback.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = page.querySelector('[data-smart-shortlist-source][data-current="true"]');
        if (source) {
          const item = sanitize(source.dataset);
          sourceMap.set(handle, item);
          return item;
        }
      } catch {
        return fallback;
      }
      return fallback;
    }

    async function toggleButton(button) {
      const handle = button.dataset.shortlistHandle;
      if (!handle) return;
      const existing = shortlist.findIndex((item) => item.handle === handle);
      if (existing >= 0) {
        shortlist.splice(existing, 1);
        writeStorage();
        transitionRender();
        announce(root.dataset.removedStatus);
        return;
      }
      if (shortlist.length >= maximum) {
        announce(root.dataset.limit);
        if (dock) dock.animate([{ transform: 'translateX(-50%)' }, { transform: 'translateX(calc(-50% - 8px))' }, { transform: 'translateX(-50%)' }], { duration: 260 });
        return;
      }
      const label = button.querySelector('[data-shortlist-action-label]');
      if (label) label.textContent = root.dataset.loading;
      button.disabled = true;
      const card = button.closest('.machine-card');
      const item = sourceMap.get(handle) || await fetchSource(card || document, handle);
      button.disabled = false;
      if (!item?.handle) {
        renderButtons();
        return;
      }
      shortlist.push(sanitize(item));
      writeStorage();
      transitionRender();
      announce(root.dataset.addedStatus);
    }

    function injectCardButtons() {
      document.querySelectorAll('.machine-card[data-product-handle]:not([data-shortlist-enhanced])').forEach((card) => {
        const handle = card.dataset.productHandle;
        const actions = card.querySelector('.machine-card__actions');
        if (!handle || !actions) return;
        card.dataset.shortlistEnhanced = 'true';
        const button = make('button', 'machine-card__button machine-card__button--secondary smart-shortlist-trigger smart-shortlist-trigger--card');
        button.type = 'button';
        button.dataset.shortlistHandle = handle;
        button.setAttribute('aria-pressed', 'false');
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('aria-hidden', 'true');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M12 5v14M5 12h14');
        icon.append(path);
        const label = make('span', '', root.dataset.add);
        label.dataset.shortlistActionLabel = '';
        button.append(icon, label);
        actions.append(button);
      });
      renderButtons();
    }

    function productHeader(item, index, decision) {
      const wrapper = make('div', 'smart-shortlist__product-head');
      wrapper.append(makeMedia(item, 'smart-shortlist__product-head-media'));
      if (item.model || item.family) wrapper.append(make('small', '', item.model || item.family));
      wrapper.append(make('strong', '', item.title));
      if (Number.isFinite(decision?.scores?.[index])) {
        const score = Math.round(decision.scores[index] * 100);
        const isTop = decision.topIndices.includes(index);
        const signal = make('span', `smart-shortlist__signal${isTop ? ' smart-shortlist__signal--top' : ''}`);
        signal.textContent = `${isTop ? `${root.dataset.decisionTop} · ` : ''}${score}% ${root.dataset.decisionScore}`;
        wrapper.append(signal);
      }
      const link = make('a', '', root.dataset.view);
      link.href = item.url || `/products/${item.handle}`;
      wrapper.append(link);
      return wrapper;
    }

    function displayed(value) {
      return value?.trim() || root.dataset.fallback;
    }

    function normalize(value) {
      return displayed(value).toLocaleLowerCase().replace(/\s+/g, ' ').trim();
    }

    function readinessSignal(item) {
      const fields = ['electrical', 'air', 'installation', 'training'];
      return fields.filter((field) => Boolean(item[field]?.trim())).length / fields.length;
    }

    function decimal(value) {
      return Number.parseFloat(String(value).replace(',', '.'));
    }

    function powerSignal(value) {
      const text = String(value || '').replace(',', '.');
      let match = text.match(/(\d+(?:\.\d+)?)\s*k\s*w\b/i);
      if (match) return { kind: 'kilowatt', value: decimal(match[1]) };
      match = text.match(/(\d+(?:\.\d+)?)\s*w\b/i);
      if (match) return { kind: 'kilowatt', value: decimal(match[1]) / 1000 };
      match = text.match(/(\d+(?:\.\d+)?)\s*(?:short\s+tons?|metric\s+tons?|tonnes?|tons?|t)\b/i);
      if (match) return { kind: 'tonnage', value: decimal(match[1]) };
      return null;
    }

    function workingAreaSignal(value) {
      const text = String(value || '').toLocaleLowerCase().replace(/,/g, '.');
      const numbers = [...text.matchAll(/\d+(?:\.\d+)?/g)].map((match) => decimal(match[0]));
      if (!numbers.length) return null;
      const isArea = numbers.length >= 2 && /[x×]/.test(text);
      let factor = 1;
      let kind = isArea ? 'raw-area' : 'raw-length';
      if (/\bmm\b/.test(text)) {
        factor = isArea ? 0.000001 : 0.001;
        kind = isArea ? 'area' : 'length';
      } else if (/\bcm\b/.test(text)) {
        factor = isArea ? 0.0001 : 0.01;
        kind = isArea ? 'area' : 'length';
      } else if (/\b(?:in|inch|inches)\b|[″\"]/.test(text)) {
        factor = isArea ? 0.00064516 : 0.0254;
        kind = isArea ? 'area' : 'length';
      } else if (/\b(?:ft|foot|feet)\b|[′']/.test(text)) {
        factor = isArea ? 0.092903 : 0.3048;
        kind = isArea ? 'area' : 'length';
      } else if (/\bm\b/.test(text)) {
        kind = isArea ? 'area' : 'length';
      }
      const amount = isArea ? numbers[0] * numbers[1] : numbers[0];
      return { kind, value: amount * factor };
    }

    function normalizedVector(extractor) {
      const extracted = shortlist.map((item) => extractor(item));
      if (extracted.some((entry) => !entry || !Number.isFinite(entry.value))) return null;
      if (new Set(extracted.map((entry) => entry.kind)).size !== 1) return null;
      const values = extracted.map((entry) => entry.value);
      const minimum = Math.min(...values);
      const maximumValue = Math.max(...values);
      if (maximumValue === minimum) return values.map(() => 1);
      return values.map((value) => (value - minimum) / (maximumValue - minimum));
    }

    function decisionData() {
      const families = shortlist.map((item) => item.family?.trim().toLocaleLowerCase()).filter(Boolean);
      const sameFamily = families.length === shortlist.length && new Set(families).size === 1;
      const readiness = shortlist.map(readinessSignal);
      const power = sameFamily ? normalizedVector((item) => powerSignal(item.power)) : null;
      const area = sameFamily ? normalizedVector((item) => workingAreaSignal(item.workingArea)) : null;
      let components = [];
      let reason = root.dataset.reasonBalanced;

      if (decisionFocus === 'power') {
        if (power) components = [{ values: power, weight: 1 }];
        reason = root.dataset.reasonPower;
      } else if (decisionFocus === 'area') {
        if (area) components = [{ values: area, weight: 1 }];
        reason = root.dataset.reasonArea;
      } else if (decisionFocus === 'readiness') {
        components = [{ values: readiness, weight: 1 }];
        reason = root.dataset.reasonReadiness;
      } else {
        if (power) components.push({ values: power, weight: 0.4 });
        if (area) components.push({ values: area, weight: 0.3 });
        components.push({ values: readiness, weight: 0.3 });
        if (!sameFamily) reason = root.dataset.reasonReadiness;
      }

      if (!components.length) {
        return { scores: [], topIndices: [], missing: true, mixed: !sameFamily, reason };
      }
      const totalWeight = components.reduce((sum, component) => sum + component.weight, 0);
      const scores = shortlist.map((item, index) => {
        const weighted = components.reduce((sum, component) => sum + component.values[index] * component.weight, 0);
        return weighted / totalWeight;
      });
      const topScore = Math.max(...scores);
      const topIndices = scores.reduce((indices, score, index) => {
        if (Math.abs(score - topScore) < 0.001) indices.push(index);
        return indices;
      }, []);
      return { scores, topIndices, missing: false, mixed: !sameFamily, reason };
    }

    function renderDecision() {
      const decision = decisionData();
      if (!decisionHost) return decision;
      const label = make('small', '', decision.topIndices.length > 1 ? root.dataset.decisionTie : root.dataset.decisionTop);
      if (decision.missing) {
        decisionHost.replaceChildren(label, make('strong', '', root.dataset.decisionMissing));
        return decision;
      }
      const names = decision.topIndices.map((index) => shortlist[index].model || shortlist[index].title).join(' / ');
      const score = Math.round(decision.scores[decision.topIndices[0]] * 100);
      const headline = make('strong', '', `${names} · ${score}% ${root.dataset.decisionScore}`);
      const explanation = make('p', '', `${decision.reason}${decision.mixed ? ` ${root.dataset.decisionMixed}` : ''}`);
      decisionHost.replaceChildren(label, headline, explanation);
      return decision;
    }

    function renderReadiness() {
      if (!readinessHost) return;
      const fields = ['electrical', 'air', 'installation', 'training'];
      const total = Math.max(shortlist.length * fields.length, 1);
      const documented = shortlist.reduce((sum, item) => {
        return sum + fields.filter((field) => Boolean(item[field]?.trim())).length;
      }, 0);
      const score = Math.round((documented / total) * 100);
      const scoreWrap = make('div', 'smart-shortlist__readiness-score');
      const ring = make('div', 'smart-shortlist__readiness-ring');
      ring.style.setProperty('--readiness-score', `${score}%`);
      ring.append(make('strong', '', `${score}%`));
      const label = make('div');
      label.append(make('b', '', root.dataset.readinessTitle));
      label.append(make('span', '', `${documented}/${total} ${root.dataset.readinessCoverage}`));
      scoreWrap.append(ring, label);
      const complete = documented === total;
      const copy = make('p', 'smart-shortlist__readiness-copy', complete ? root.dataset.readinessComplete : root.dataset.readinessNeeded);
      readinessHost.replaceChildren(scoreWrap, copy);
    }

    function renderTable() {
      if (!tableHost) return;
      renderReadiness();
      const decision = renderDecision();
      const rows = [
        ['power', root.dataset.metricPower],
        ['workingArea', root.dataset.metricArea],
        ['electrical', root.dataset.metricElectrical],
        ['air', root.dataset.metricAir],
        ['installation', root.dataset.metricInstallation],
        ['training', root.dataset.metricTraining]
      ];
      const table = make('table', 'smart-shortlist__table');
      const head = document.createElement('thead');
      const headRow = document.createElement('tr');
      const specification = make('th', '', root.dataset.specification);
      specification.scope = 'col';
      headRow.append(specification);
      shortlist.forEach((item, index) => {
        const cell = document.createElement('th');
        cell.scope = 'col';
        cell.append(productHeader(item, index, decision));
        headRow.append(cell);
      });
      head.append(headRow);
      table.append(head);

      const body = document.createElement('tbody');
      rows.forEach(([key, label]) => {
        const values = shortlist.map((item) => displayed(item[key]));
        const different = new Set(values.map(normalize)).size > 1;
        if (differencesToggle?.checked && !different) return;
        const row = document.createElement('tr');
        const metric = make('th', 'smart-shortlist__metric', label);
        metric.scope = 'row';
        row.append(metric);
        values.forEach((value) => {
          const cell = make('td', `smart-shortlist__value${different ? ' smart-shortlist__value--different' : ''}`, value);
          row.append(cell);
        });
        body.append(row);
      });
      table.append(body);
      tableHost.replaceChildren(table);

      if (quoteLink) {
        const params = new URLSearchParams();
        const handles = shortlist.map((item) => item.handle).join(',');
        params.set('route', 'machine');
        params.set('source', 'smart-shortlist');
        params.set('comparison', handles);
        params.set('machines', handles);
        if (shortlist.length === 1) params.set('machine', handles);
        params.set('focus', decisionFocus);
        const models = shortlist.map((item) => item.model).filter(Boolean);
        if (models.length) params.set('models', models.join(','));
        if (decision.topIndices.length) {
          params.set('top_signal', decision.topIndices.map((index) => shortlist[index].handle).join(','));
        }
        quoteLink.href = `/pages/request-equipment-quote?${params.toString()}`;
      }
    }

    function comparisonUrl() {
      const url = new URL('/', window.location.origin);
      url.searchParams.set('compare', shortlist.map((item) => item.handle).join(','));
      url.searchParams.set('focus', decisionFocus);
      url.searchParams.set('utm_source', 'machine-comparison');
      return url.toString();
    }

    async function shareComparison() {
      const url = comparisonUrl();
      if (navigator.share) {
        try {
          await navigator.share({ title: root.dataset.shareTitle, url });
          announce(root.dataset.sharedStatus);
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
      } catch {
        const field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.append(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      announce(root.dataset.sharedStatus);
    }

    function openComparison(opener) {
      dialogOpener = opener instanceof HTMLElement ? opener : null;
      renderTable();
      if (dialog && !dialog.open) dialog.showModal();
      closeButton?.focus({ preventScroll: true });
    }

    async function loadSharedComparison() {
      const raw = new URLSearchParams(window.location.search).get('compare');
      if (!raw) return;
      const handles = [...new Set(raw.split(',').map((handle) => handle.trim()).filter((handle) => /^[a-z0-9-]+$/i.test(handle)))].slice(0, maximum);
      if (!handles.length) return;
      const restored = [];
      for (const handle of handles) {
        const item = sourceMap.get(handle) || await fetchSource(document, handle);
        if (item?.handle) restored.push(sanitize(item));
      }
      if (!restored.length) return;
      shortlist = restored;
      writeStorage();
      transitionRender();
      announce(root.dataset.loadedStatus);
      if (shortlist.length >= 2) openComparison(null);
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.smart-shortlist-trigger');
      if (trigger) {
        toggleButton(trigger);
        return;
      }
      const remove = event.target.closest('[data-shortlist-remove]');
      if (remove) {
        shortlist = shortlist.filter((item) => item.handle !== remove.dataset.shortlistRemove);
        writeStorage();
        transitionRender();
        announce(root.dataset.removedStatus);
      }
    });

    compareButton?.addEventListener('click', (event) => {
      if (shortlist.length < 2) {
        announce(root.dataset.twoRequired);
        return;
      }
      openComparison(event.currentTarget);
    });

    closeButton?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog?.addEventListener('close', () => {
      if (dialogOpener?.isConnected) dialogOpener.focus({ preventScroll: true });
      dialogOpener = null;
    });
    differencesToggle?.addEventListener('change', renderTable);
    focusInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked || !allowedFocus.has(input.value)) return;
        decisionFocus = input.value;
        writeFocus();
        renderTable();
      });
    });
    shareButton?.addEventListener('click', shareComparison);
    printButton?.addEventListener('click', () => {
      renderTable();
      document.body.classList.add('smart-shortlist-printing');
      window.print();
    });
    window.addEventListener('afterprint', () => document.body.classList.remove('smart-shortlist-printing'));
    clearButton?.addEventListener('click', () => {
      shortlist = [];
      writeStorage();
      transitionRender();
    });
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey) {
        shortlist = readStorage();
        transitionRender();
      }
      if (event.key === focusStorageKey && allowedFocus.has(event.newValue)) {
        decisionFocus = event.newValue;
        focusInputs.forEach((input) => {
          input.checked = input.value === decisionFocus;
        });
        if (dialog?.open) renderTable();
      }
    });

    const observer = new MutationObserver(() => window.requestAnimationFrame(injectCardButtons));
    observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    injectCardButtons();
    render();
    loadSharedComparison();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["umpro-predictive-search"] && !Shopify.designMode) return;
  try {
    class UmproPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.hydrated = false;
      this.listenerController = new AbortController();
      const signal = this.listenerController.signal;

      document.querySelectorAll('[data-umpro-search-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.open(trigger), { signal });
      });

      document.addEventListener('keydown', (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
          event.preventDefault();
          this.dialog.open ? this.close() : this.open(document.activeElement);
          return;
        }

        const target = event.target;
        const isEditable = target instanceof HTMLElement && (
          target.matches('input, textarea, select') || target.isContentEditable
        );
        if (event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey && !isEditable) {
          event.preventDefault();
          this.open(document.activeElement);
        }
      }, { signal });
    }

    hydrate() {
      if (this.hydrated) return;
      this.hydrated = true;
      this.input = this.querySelector('[data-umpro-search-input]');
      this.results = this.querySelector('[data-umpro-search-results]');
      this.status = this.querySelector('[data-umpro-search-status]');
      this.clearButton = this.querySelector('[data-umpro-search-clear]');
      this.allResults = this.querySelector('[data-umpro-search-all]');
      this.initialResults = this.results.innerHTML;
      this.activeIndex = -1;
      this.abortController = null;
      this.timer = null;
      this.lastOpener = null;
      this.cache = new Map();
      this.rewriteAttempts = new Set();
      const signal = this.listenerController.signal;

      this.querySelector('[data-umpro-search-close]').addEventListener('click', () => this.close(), { signal });
      this.clearButton.addEventListener('click', () => this.reset(true), { signal });
      this.input.addEventListener('input', () => this.schedule(), { signal });
      this.input.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, { signal });
      this.dialog.addEventListener('cancel', () => {
        document.documentElement.classList.remove('umpro-search-is-open');
      }, { signal });
      this.dialog.addEventListener('close', () => this.onClose(), { signal });
      this.results.addEventListener('click', (event) => this.onResultsClick(event), { signal });
      this.allResults.addEventListener('click', () => {
        this.track('umpro_search_view_all', { query: this.input.value.trim() });
      }, { signal });

      this.querySelectorAll('[data-umpro-search-query]').forEach((button) => {
        button.addEventListener('click', () => {
          this.input.value = button.dataset.umproSearchQuery || '';
          this.clearButton.hidden = false;
          this.search();
          this.input.focus();
        }, { signal });
      });

      this.renderRecentSearches();
    }

    disconnectedCallback() {
      this.listenerController?.abort();
      this.abortController?.abort();
      window.clearTimeout(this.timer);
    }

    transition(action) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reducedMotion) {
        document.startViewTransition(action);
      } else {
        action();
      }
    }

    open(trigger) {
      this.hydrate();
      this.lastOpener = trigger instanceof HTMLElement ? trigger : null;
      if (!this.dialog.open) this.dialog.showModal();
      this.input.focus({ preventScroll: true });
      document.documentElement.classList.add('umpro-search-is-open');
      this.track('umpro_search_open', { page: window.location.pathname });
    }

    close() {
      document.documentElement.classList.remove('umpro-search-is-open');
      if (this.dialog.open) this.dialog.close();
    }

    onClose() {
      document.documentElement.classList.remove('umpro-search-is-open');
      this.reset(false);
      this.lastOpener?.focus();
    }

    reset(keepFocus) {
      this.abortController?.abort();
      window.clearTimeout(this.timer);
      this.rewriteAttempts.clear();
      this.input.value = '';
      this.input.removeAttribute('aria-activedescendant');
      this.input.setAttribute('aria-expanded', 'false');
      this.results.setAttribute('aria-busy', 'false');
      this.results.innerHTML = this.initialResults;
      this.renderRecentSearches();
      this.status.textContent = '';
      this.clearButton.hidden = true;
      this.allResults.hidden = true;
      this.querySelectorAll('[data-umpro-search-rfq]').forEach((link) => {
        link.hidden = true;
      });
      this.activeIndex = -1;
      if (keepFocus) this.input.focus();
    }

    schedule() {
      window.clearTimeout(this.timer);
      this.rewriteAttempts.clear();
      this.clearButton.hidden = this.input.value.length === 0;
      if (this.input.value.trim().length < 2) {
        this.abortController?.abort();
        this.results.innerHTML = this.initialResults;
        this.renderRecentSearches();
        this.results.setAttribute('aria-busy', 'false');
        this.input.setAttribute('aria-expanded', 'false');
        this.allResults.hidden = true;
        this.querySelectorAll('[data-umpro-search-rfq]').forEach((link) => {
          link.hidden = true;
        });
        this.status.textContent = '';
        return;
      }
      this.timer = window.setTimeout(() => this.search(), 160);
    }

    setState(message) {
      const state = document.createElement('p');
      state.className = 'umpro-search__state';
      state.textContent = message;
      this.results.replaceChildren(state);
    }

    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) return;

      const cacheKey = query.toLocaleLowerCase();
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.activeIndex = -1;
      this.results.setAttribute('aria-busy', 'true');
      this.setState(this.dataset.loading || '');
      this.status.textContent = this.dataset.loading || '';
      this.input.setAttribute('aria-expanded', 'false');

      const allUrl = new URL(this.dataset.searchUrl, window.location.origin);
      allUrl.searchParams.set('q', query);
      allUrl.searchParams.set('options[prefix]', 'last');
      this.allResults.href = allUrl.pathname + allUrl.search;
      this.allResults.hidden = false;
      this.updateRfqUrl(query);

      if (this.cache.has(cacheKey)) {
        const cachedPayload = this.cache.get(cacheKey);
        if (this.trySearchRewrite(query, cachedPayload)) return;
        this.renderPayload(cachedPayload, query);
        return;
      }

      const url = new URL(this.dataset.endpoint, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'query,product,collection,page,article');
      url.searchParams.set('resources[limit]', '5');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set(
        'resources[options][fields]',
        'title,body,product_type,tag,vendor,variants.sku,variants.title'
      );
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.abortController.signal
        });
        if (!response.ok) throw new Error('Search request failed');
        const html = await response.text();
        const resultDocument = new DOMParser().parseFromString(html, 'text/html');
        const payload = resultDocument.querySelector('[data-umpro-search-results-payload]');
        if (!payload) throw new Error('Search results payload missing');

        const cacheValue = {
          html: payload.innerHTML,
          summary: payload.dataset.summary || '',
          count: Number(payload.dataset.count || 0)
        };
        this.cache.set(cacheKey, cacheValue);
        if (this.cache.size > 12) {
          this.cache.delete(this.cache.keys().next().value);
        }
        if (this.trySearchRewrite(query, cacheValue)) return;
        this.renderPayload(cacheValue, query);
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        this.results.setAttribute('aria-busy', 'false');
        this.setState(this.dataset.error || '');
        this.status.textContent = this.dataset.error || '';
        this.input.setAttribute('aria-expanded', 'false');
      }
    }

    trySearchRewrite(query, payload) {
      if (payload.count > 0) return false;

      const correctedQuery = this.getSearchCorrection(query);
      if (!correctedQuery) return false;

      const attemptKey = query.toLocaleLowerCase() + '=>' + correctedQuery.toLocaleLowerCase();
      if (this.rewriteAttempts.has(attemptKey)) return false;

      this.rewriteAttempts.add(attemptKey);
      this.input.value = correctedQuery;
      this.clearButton.hidden = false;
      this.track('umpro_search_rewrite', {
        query,
        corrected_query: correctedQuery.slice(0, 120)
      });
      this.search();
      return true;
    }

    getSearchCorrection(query) {
      const normalized = query
        .toLocaleLowerCase()
        .replace(/[×✕]/g, 'x')
        .replace(/\s+/g, ' ')
        .trim();

      const corrected = normalized
        .replace(/\bfibre\b/g, 'fiber')
        .replace(/\bfiberlaser\b/g, 'fiber laser')
        .replace(/\bpress\s*break\b/g, 'press brake')
        .replace(/\bpressbrake\b/g, 'press brake')
        .replace(/\btube\s+(?:cutter|cutting machine)\b/g, 'tube laser')
        .replace(/\bpipe\s+(?:cutter|laser)\b/g, 'tube laser')
        .replace(/\blaser\s+welding\s+machine\b/g, 'laser welder')
        .replace(/\blaser\s+cleaning\s+machine\b/g, 'laser cleaner')
        .replace(/\bbandsaw\b/g, 'band saw');

      return corrected !== normalized ? corrected : '';
    }

    renderPayload(payload, query) {
      this.results.innerHTML = payload.html;
      this.results.setAttribute('aria-busy', 'false');
      this.status.textContent = payload.summary;
      this.assignOptionIds();
      this.input.setAttribute('aria-expanded', String(payload.count > 0));
      this.storeRecentSearch(query);
      this.updateRfqUrl(query);
      this.track('umpro_search_results', {
        query,
        count: payload.count,
        has_results: payload.count > 0
      });
    }

    onResultsClick(event) {
      if (!(event.target instanceof Element)) return;

      const clearHistory = event.target.closest('[data-umpro-search-clear-history]');
      if (clearHistory) {
        this.clearRecentSearches();
        return;
      }

      const recentQuery = event.target.closest('[data-umpro-recent-query]');
      if (recentQuery instanceof HTMLButtonElement) {
        this.input.value = recentQuery.dataset.umproRecentQuery || '';
        this.clearButton.hidden = false;
        this.search();
        this.input.focus();
        return;
      }

      const rfqLink = event.target.closest('[data-umpro-search-rfq]');
      if (rfqLink instanceof HTMLAnchorElement) {
        this.track('umpro_search_rfq', { query: this.input.value.trim() });
        return;
      }

      const resultLink = event.target.closest('[role="option"]');
      if (resultLink instanceof HTMLAnchorElement) {
        const resultType = resultLink.querySelector('.umpro-search__result-type')?.textContent?.trim() || 'suggestion';
        const resultTitle = resultLink.querySelector('strong')?.textContent?.trim() || resultLink.textContent?.trim() || '';
        this.track('umpro_search_select', {
          query: this.input.value.trim(),
          result_type: resultType.slice(0, 60),
          result_title: resultTitle.slice(0, 120),
          destination: resultLink.pathname
        });
      }
    }

    getRecentSearches() {
      return [];
    }

    storeRecentSearch(query) {
      return;
    }

    clearRecentSearches() {
      try {
        sessionStorage.removeItem(this.dataset.storageKey);
      } catch {
        return;
      }
      this.renderRecentSearches();
      this.track('umpro_search_history_clear', {});
    }

    renderRecentSearches() {
      const container = this.results.querySelector('[data-umpro-recent-searches]');
      const list = this.results.querySelector('[data-umpro-recent-list]');
      if (!(container instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

      const recent = this.getRecentSearches();
      list.replaceChildren();
      container.hidden = recent.length === 0;

      recent.forEach((query) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.umproRecentQuery = query;
        button.textContent = query;
        list.append(button);
      });
    }

    updateRfqUrl(query) {
      if (!this.dataset.rfqUrl) return;

      const url = new URL(this.dataset.rfqUrl, window.location.origin);
      url.searchParams.set('search_query', query);
      url.searchParams.set('source', 'predictive-search');

      this.querySelectorAll('[data-umpro-search-rfq]').forEach((link) => {
        if (!(link instanceof HTMLAnchorElement)) return;
        link.href = url.pathname + url.search;
        link.hidden = false;
      });
    }

    track(eventName, detail) {
      const rawQuery = typeof detail?.query === 'string' ? detail.query : '';
      const detailWithoutQuery = { ...(detail || {}) };
      delete detailWithoutQuery.query;
      const safeDetail = {
        source: 'predictive-search',
        ...detailWithoutQuery,
        query_length: Math.min(rawQuery.length, 120)
      };

      this.dispatchEvent(new CustomEvent('umpro:predictive-search', {
        bubbles: true,
        detail: { event: eventName, ...safeDetail }
      }));

      if (window.UmproThemeConfig?.analyticsEnabled === true) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...safeDetail });
      }
    }

    get options() {
      return Array.from(this.results.querySelectorAll('[role="option"]'));
    }

    assignOptionIds() {
      this.options.forEach((option, index) => {
        option.id = 'UmproPredictiveOption-' + String(index + 1);
        option.setAttribute('aria-selected', 'false');
      });
    }

    onKeydown(event) {
      const options = this.options;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (!options.length) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = (this.activeIndex + direction + options.length) % options.length;
        this.selectOption(options);
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.activeIndex = 0;
        this.selectOption(options);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.activeIndex = options.length - 1;
        this.selectOption(options);
      } else if (event.key === 'Enter' && this.activeIndex >= 0) {
        event.preventDefault();
        options[this.activeIndex].click();
      }
    }

    selectOption(options) {
      options.forEach((option, index) => {
        const selected = index === this.activeIndex;
        option.classList.toggle('is-active', selected);
        option.setAttribute('aria-selected', String(selected));
      });
      const selected = options[this.activeIndex];
      this.input.setAttribute('aria-activedescendant', selected.id);
      selected.scrollIntoView({ block: 'nearest' });
    }
  }

  if (!customElements.get('umpro-predictive-search')) {
    customElements.define('umpro-predictive-search', UmproPredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
